<template>
  <van-popup v-model="showPicker" round :position="position">
    <van-picker
      :title="title"
      show-toolbar
      :columns="columns"
      @confirm="onConfirm"
      @cancel="onCancel"
      :default-index="index"
    />
  </van-popup>
</template>

<script>
    export default {
        name: "timeselect",
      props: {
        //标题
        title: {
          type: String,
          default: ''
        },
        //弹出方向
        position: {
          type: String,
          default: 'bottom'
        },
        //校区代码
        szxqdm:{
          type: String,
          default: ''
        },
        //起始时间
        qssj:{
          type: String,
          default: ''
        },
        //类型
        type: {
          type: String,
          default: ''
        },
        callbak: {
          type: Function,
          default: null,
        }

      },
      data() {
        return {
          showPicker:false,
          value:null,
          text:null,
          columns:[],
          index:0,
          dm:null,

        }
      },
      created() {
      },
      methods: {
        show(show,dm,method){
          this.showPicker = show;
          this.dm = dm;
          this.getlist();
        },
        getlist(){
          let that = this;
          let datas = {
            type:that.type,
            qssj:that.qssj,
            szxqdm: that.szxqdm
          };
          this.$ajax.post('/appapi/teacherjsjy/timeselect',datas).then(function (rep) {
            if (rep.code == 200) {
              that.columns = rep.columnsList;
              for(var i = 0;i < that.columns.length;i++){
                if(that.dm === that.columns[i].value){
                  that.index = i;
                }
              }
            }
          });
        },
        onConfirm(columns, index) {
          this.value = columns.value;
          this.text = columns.text;
          this.index = index;
           this.callbak(this.value,this.text);
          this.showPicker = false;
        },
        onCancel() {
          this.showPicker = false;
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/mobile-timeselect/timeselect.vue